import { render, staticRenderFns } from "./scMoreInfoDownload.vue?vue&type=template&id=50f33708&"
import script from "./scMoreInfoDownload.vue?vue&type=script&lang=js&"
export * from "./scMoreInfoDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports